import Product from './Product';

class Box {
  constructor(data) {
    const isDefaultData = typeof data === 'undefined';

    this.id = isDefaultData ? '' : data.id;
    this.status = isDefaultData ? '' : data.status;
    this.created_at = isDefaultData ? '' : data.created_at;
    this.updated_at = isDefaultData ? '' : data.updated_at;
    this.height = isDefaultData ? '' : data.height;
    this.width = isDefaultData ? '' : data.width;
    this.shelf = isDefaultData ? '' : data.shelf;
    this.weight = isDefaultData ? '' : data.weight;
    this.length = isDefaultData ? '' : data.length;
    this.products = [];

    if (typeof data !== 'undefined' && typeof data.products !== 'undefined') {
      for (const item of data.products) {
        this.products.push(new Product(item));
      }
    }
  }
}

export default Box;
